import * as yup from 'yup';

const schema = () =>
  yup.object().shape({
    commentNotificationEnabled: yup.boolean().nullable(),
    sendDirectoryDigest: yup.boolean().nullable(),
    sendForumDigest: yup.boolean().nullable(),
    sendMarketingEmails: yup.boolean().nullable(),
    surveyEnabled: yup.boolean().nullable(),
    weeklyBookmarkDigestEnabled: yup.boolean().nullable(),
  });

export default schema;
